import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class WalletErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/wallet\/apple/,
      messages: {
        400: 'errors.walletFailed',
        404: 'errors.walletFailed',
        412: 'errors.walletInvalidMembershipCardToken',
        500: 'errors.walletFailed',
        success: {
          default: 'errors.walletFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/wallet\/google/,
      messages: {
        400: 'errors.walletFailed',
        404: 'errors.walletFailed',
        412: 'errors.walletInvalidMembershipCardToken',
        500: 'errors.walletFailed',
        success: {
          default: 'errors.walletFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/wallet\/census/,
      messages: {
        400: 'errors.walletFailed',
        404: 'errors.walletFailed',
        412: 'errors.walletInvalidMembershipCardToken',
        500: 'errors.walletFailed',
        success: {
          default: 'errors.walletFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
